export const SAVE_DEFAULTS_DIALOG_TEXT =
  'You have made changes to the time range or the variables values. Would you like to save these as defaults?';
export const SAVE_DEFAULT_TIME_RANGE_TEXT =
  'You have made changes to the time range. Would you like to save this as default?';
